import $ from 'jquery';
import '../../utility/csrf';
import AppStore from '../../stores/AppStore';
import { normalizeNumber } from '../../utility/formator';
import { showSpinnerOverlay, hideSpinnerOverlay } from '../../utility/helper';
import templateData, { isPartnerFlow } from '../../utility/getTemplateData';

export function guestPayment(params = {}) {
  showSpinnerOverlay();
  let { token } = templateData;

  params.donationAmount = normalizeNumber(AppStore.getDonationAmount());
  params.currencyCode = AppStore.getDonationCode();
  params.currencySymbol = AppStore.getDonationSymbol();
  params.addressSharingConsent = AppStore.getShareAddress();
  params.note = AppStore.getDonationNote();
  params.recurring = AppStore.getDonationRecurring();
  params.giftAidItFlag = AppStore.getGiftaidItFlagStatus() || false;
  params.selectedProgram = AppStore.getSelectedProgram();
  params.isPartnerFlow = isPartnerFlow();
  params.isVoucherFlow = templateData.isVoucherFlow;
  params.offerProgram = templateData.offerProgram;
  params.token = token;

  return new Promise((resolve, reject) => {
    $.post('/donate/guest/onboarding', params, (result) => {
      return resolve(result);
    })
      .fail((err) => {
        return reject(err);
      })
      .always(() => {
        hideSpinnerOverlay();
      });
  });
}
